import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/init';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/layout.css';
import { AuthProvider } from './authContext';


import ReactGA from "react-ga4";
ReactGA.initialize([
  {
    trackingId: "G-RTK3E12KVF",
    gtagOptions: { debug_mode: process.env.NODE_ENV !== 'production' }
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
